import { render, staticRenderFns } from "./ProgramHero.vue?vue&type=template&id=30fa49f5&scoped=true&"
import script from "./ProgramHero.vue?vue&type=script&lang=ts&"
export * from "./ProgramHero.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramHero.vue?vue&type=style&index=0&id=30fa49f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fa49f5",
  null
  
)

export default component.exports